import { parsePhoneNumberFromString } from 'libphonenumber-js';

const validNameRegex = /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]{2,50}$/;

export function getNameWarning (name) {
  if (!name || name.trim().length === 0) {
    return 'Name is required';
  }

  name = name.trim();

  if (name.length < 2) {
    return 'Name is too short';
  }

  if (name.length > 50) {
    return 'Name is too long';
  }

  if (validNameRegex.test(name)) {
    return '';
  }
  else {
    return 'Invalid name';
  }
}

const validEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function getEmailWarning (email) {
  if (!email || email.trim().length === 0) {
    return 'Email is required';
  }

  if (!validEmailRegex.test(email) ||
      email.includes('..')) {
    return 'Invalid email';
  }

  const [localPart, domain] = email.split('@');

  if (!localPart || !domain ||
      localPart.startsWith('.') ||
      localPart.endsWith('.') ||
      !domain.includes('.') ||
      domain.startsWith('.') ||
      domain.endsWith('.')) {
    return 'Invalid email';
  }

  const domainParts = domain.split('.');
  const tld = domainParts[domainParts.length - 1];
  if (tld.length < 2) {
    return 'Invalid email';
  }

  return '';
}

export function getPhoneWarning (phoneNumber) {
  if (!phoneNumber || phoneNumber.trim().length === 0) {
    return 'Phone number is required';
  }

  const parsedNumber = parsePhoneNumberFromString(phoneNumber, 'US');

  if (!parsedNumber) {
    return 'Invalid phone number format';
  }

  if (!parsedNumber.isValid()) {
    return 'Invalid phone number';
  }

  return '';
}

export function getPasswordWarning (password, target) {
  if (password === '') return '';

  if (password.length < 8) {
    return 'Password is less than 8 characters';
  }
  else if (!password.match(/[A-Z]/)) {
    return 'Password does not contain an uppercase letter';
  }
  else if (!password.match(/[0-9]/)) {
    return 'Password does not contain a number';
  }
  else if (target && password !== target) {
    return 'Passwords do not match';
  }
  else {
    return '';
  }
}

const validDomainRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

export function getDomainWarning(domain) {
  if (!domain || domain.trim().length === 0) {
    return 'Domain is required';
  }

  domain = domain.trim().toLowerCase();

  if (domain.length > 253) {
    return 'Domain is too long';
  }

  if (validDomainRegex.test(domain)) {
    return '';
  } else {
    return 'Invalid domain';
  }
}
